// Module
var code = `<uib-tabset>
    <uib-tab index="0" heading="Rewards">
        <br/>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.CollectRewardDAURookies"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.CollectRewardDAUOfficers"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.CollectRewardDAUCommanders"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.CollectRewardDAUVeterans"></bfg-chart>
            </div>
        </div>
    </uib-tab>

    <uib-tab index="1" heading="Bonuses">
        <br/>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.CollectBonusDAURookies"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.CollectBonusDAUOfficers"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.CollectBonusDAUCommanders"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.CollectBonusDAUVeterans"></bfg-chart>
            </div>
        </div>
    </uib-tab>

    <uib-tab index="2" heading="Income">
        <br/>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.IncomeFromEvent"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.IncomeFromRookies"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.IncomeFromOfficers"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.IncomeFromCommanders"></bfg-chart>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <bfg-chart name="game_events.IncomeFromVeterans"></bfg-chart>
            </div>
        </div>
    </uib-tab>
</uib-tabset>
`;
// Exports
module.exports = code;